
import { Roles } from "src/app/shared/model/Roles";
import { UserData } from "./UserData";
import { UserProfile } from "./UserProfile";

export class User {

  public userData!: UserData;
  public userRoles!: string[];
  public userAbilities!: string[];
  public userRestrictions!: string[];
  public userProfilesHashes!: string[];

  getDisplayName() {
    return this.userData.name + ' ' + this.userData.surname;
  }

  public getLoggedUserProfile(referenceType: number): UserProfile | null {

    const hash = this.userProfilesHashes.find(x => x.includes("|" + referenceType + "|"));
    if (!hash) {
      return null;
    }

    const items = hash.split("|", 3);
      if(items?.length < 3){
        return null;
      }
  
     return {
        referenceId : parseInt(items[0]),
        referenceType : parseInt(items[1]),
        referenceDescription: items[2]
      }
  }

  public getLoggedUserProfileByPriority(): UserProfile | null {

    let hash: string | undefined;
    //main portal rights
    if(this.hasRole(Roles.PortalUser)){
      hash = this.userProfilesHashes.find(x => x.includes("|20|"));
    }

    //mobile rights
    if(!hash && this.hasRole(Roles.MobileAppUser)){
      hash = this.userProfilesHashes.find(x => x.includes("|20|"));
    }

    //workshop rights
    if(!hash && this.hasRole(Roles.WorkshopUser)){
      hash = this.userProfilesHashes.find(x => x.includes("|6|"));
    }

     //dealer rights
    if(!hash && this.hasRole(Roles.DealerUser)){
      hash = this.userProfilesHashes.find(x => x.includes("|52|"));
    }

     //parts supplier rights
    if(!hash && this.hasRole(Roles.PartsSupplierUser)){
      hash = this.userProfilesHashes.find(x => x.includes("|38|"));
    }

     //calculator rights
    if(!hash && this.hasRole(Roles.CalculatorUser)){
      hash = this.userProfilesHashes.find(x => x.includes("|56|"));
    }

    if(!hash){
      return null;
    }

    const items = hash.split("|",3);
      if(items?.length < 3){
        return null;
      }
  
     return {
        referenceId : parseInt(items[0]),
        referenceType : parseInt(items[1]),
        referenceDescription: items[2]
      }
  }
  
  public hasRole(roleName: string): boolean {

    return this.userRoles.findIndex(x => x === roleName) > -1;
  }
}
